import notifly from 'notifly-js-sdk';
import { EventHandler } from './base';
import { EventType, ReservationEvent } from '../../model/tracker';

const notiflyEvents: Array<EventType> = [ReservationEvent.COMPLETE_HOSPITALADMIN_VISIT];

export class NotiflyHandler implements EventHandler {
  private projectId = process.env.REACT_APP_NOTIFLY_PROJECT_ID || '';

  private username = process.env.REACT_APP_NOTIFLY_PROJECT_USERNAME || '';

  private password = process.env.REACT_APP_NOTIFLY_PROJECT_PASSWORD || '';

  initialize = () => {
    if (typeof window !== 'undefined') {
      notifly.initialize({
        projectId: this.projectId,
        username: this.username,
        password: this.password,
      });
    }
  };

  setUserID = (userId: string) => {
    notifly.setUserId(userId);
  };

  handleEvent = (event: EventType, properties: Record<string, any>) => {
    if (!notifly || !notiflyEvents.includes(event)) {
      return;
    }

    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      console.log(`%c Notifly handleEvent`, 'color: red; background: #ffb6c16b', { event, properties });
    }

    notifly.trackEvent(event, properties);
  };
}
